









































import { Vue, Component } from "vue-property-decorator";
import dayjs from "dayjs";
import { namespace } from "vuex-class";
import { Invoice } from "../types";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const utc = require("dayjs/plugin/utc");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const timezone = require("dayjs/plugin/timezone");

dayjs.extend(utc);
dayjs.extend(timezone);

const Subscriptions = namespace("subscriptions");
@Component({})
export default class PaymentHistory extends Vue {
  @Subscriptions.Action("fetchAllInvoices")
  fetchAllInvoices!: () => Promise<{}>;
  @Subscriptions.Getter("getAllInvoices") invoices!: Invoice[];

  mounted() {
    this.fetchAllInvoices();
  }

  localDate(date: string) {
    return dayjs(date).format("MMM D YYYY");
  }
  localTime(date: string) {
    return dayjs(date).subtract(5, "hour").format("h:mm a");
  }
}
